exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button {\n  float: right;\n  margin-top: 2.5em;\n  font-size: .9em;\n  font-weight: 500;\n  text-transform: uppercase;\n  padding: .75em 1em;\n  border: none;\n  outline: none;\n  border-radius: 10px;\n  background: #696D7D;\n  color: white;\n  cursor: pointer;\n  -webkit-transition: background .1s;\n  transition: background .1s; }\n\nbutton:hover {\n  background: #606472; }\n\nbutton:active {\n  background: #4D505B; }\n\nh1 {\n  display: inline-block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/controls/controls.component.scss
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/tic-tac-toe/controls/controls.component.scss
// module chunks = main